import React, { useEffect, useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import { HeaderAnalysisThreatScoringSettingProps } from './HeaderAnalysisThreatScoringSetting.props';
import './HeaderAnalysisThreatScoringSetting.styles.css';
import { CommonSettingCard } from '../CommonSettingCard';
import { resolveHeaderAnalysisPolicy, saveHeaderAnalysisPolicy } from '../../../api/emailTriage';
import { useRoleContext } from '../../../context/RoleContext';
import { SETTING_TYPE_HEADER_ANALYSIS_THREAT_SCORING } from '../../../constants/contants';

export const HeaderAnalysisThreatScoringSetting: React.FC<HeaderAnalysisThreatScoringSettingProps> = ({
  defaultEnabled = false,
}) => {
  const { setSetting } = useRoleContext();
  const [policySettings, setPolicySettings] = useState<{ enabled: boolean; checks: any }>({
    enabled: defaultEnabled,
    checks: undefined,
  });
  const [revision, setRevision] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    resolveHeaderAnalysisPolicy()
      .then((response) => {
        if (cancelled) return;
        const { policy } = response.data;
        setPolicySettings({
          enabled: policy.enabled,
          checks: policy.checks,
        });
        setRevision(policy.revision);
      })
      .catch((e) => console.log(e))
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const handleToggle = async (checked: boolean) => {
    const response = await saveHeaderAnalysisPolicy({
      settings: { ...policySettings, enabled: checked },
      expectedRevision: revision,
    });

    if (response?.status === 200) {
      const { policy } = response.data;
      setPolicySettings({
        enabled: policy.enabled,
        checks: policy.checks,
      });
      setRevision(policy.revision);
      setSetting((current: any) => ({
        ...current,
        [SETTING_TYPE_HEADER_ANALYSIS_THREAT_SCORING]: policy.enabled,
      }));
    }

    return response;
  };

  return (
    <Box className="header-analysis-threat-scoring-wrapper">
      <Box className="title-domain">
        <Box sx={{ fontSize: '18px'}}>
          <strong>Header Analysis: Threat Score Rules</strong> 
          <Tooltip
            placement={'top'}
            sx={{ marginLeft: '10px'}}
            title={
              "Every email gets two safety scores. One checks the Threat Score Rules using your custom rules. The other runs automatic security checks on things like attachments and sender reputation. The higher score is used as the final result."
            }
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: '580px',
                  fontSize: '13px',
                  padding: '8px',
                },
              },
            }}
          >
            <IconButton className="info-action">
              <HelpIcon fontSize={'small'} htmlColor={'#193051'} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
      <Box sx={{ marginTop: '32px' }}>
        <CommonSettingCard
          description="Enable Header Analysis in Threat Scoring"
          helperText="When disabled, header checks will not contribute to the threat score calculation."
          status={policySettings.enabled}
          loading={loading}
          onToggle={handleToggle}
        />
      </Box>
    </Box>
  );
};
